import { ContenitoreBase, useApi, useApiCallback } from 'gf-ui';
import { useEffect, useMemo, useState } from 'react';
import { Accordion, Button, Col, Container, Form, InputGroup, Row, Table } from 'react-bootstrap';
import { FaSearch, FaTimesCircle } from 'react-icons/fa';
import { FaListCheck } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { API_SERVICES } from '..';
import BreadcrumbGF from '../../libQuestionario/components/BreadcrumbGF';
import { apiMalattieRare } from './api/apiMalattieRare';
import MRHeader from './components/MRHeader';


const MRCerca = () => {
  const apiCallback = useApiCallback()
  const dispatch = useDispatch()
  const [search, setSearch] = useState("")
  const token = useSelector( state => state.user.token )  
  const _apiMalattieRare = useApi(apiMalattieRare)
  const [centri, setCentri] = useState(null)
  const [centriFiltered, setCentriFiltered] = useState(null)
  const [curAccordion, setCurAccordion] = useState(null)

  const compare = (a, b) => {
    if (a.DESCRIZIONE < b.DESCRIZIONE) {
      return -1;
    }
    if (a.DESCRIZIONE > b.DESCRIZIONE) {
      return 1;
    }
    return 0;
  }

  useEffect(() => {
    _apiMalattieRare && _apiMalattieRare?.fnMalattieRare(res => {
      setCentri(res.centri)
    })
  }, [token, dispatch, apiCallback, _apiMalattieRare])

  useEffect(() => {
    setCurAccordion(null)
    if (search !== "") {
      let _centri = JSON.parse(JSON.stringify(centri));
      let _centriFiltered = _centri.filter(item => {
        let _filter = item.ARR_MALATTIE_RARE.filter(m => m.CODICE_ESENZIONE.toLowerCase().indexOf(search.toLowerCase()) >= 0 || m.DESCRIZIONE.toLowerCase().indexOf(search.toLowerCase()) >= 0);
        if (_filter.length > 0 || item.DESCRIZIONE.toLowerCase().indexOf(search.toLowerCase()) >= 0) {
          return item;
        } else {
          return null;
        }
      })
      setCentriFiltered(_centriFiltered)
    } else {
      setCentriFiltered(centri)
    }
  }, [search, centri])

  const clickItem = (index) => {
    if (curAccordion === index) {
      setCurAccordion(null)
    } else {
      setCurAccordion(index)
    }
  }

  const breadcrumbItems = useMemo(()=>{
    return [      
      { label: API_SERVICES.MR.NOME }
    ]
  }, [])

  return (
    <>
      <Container fluid className='p-0 m-0 bg-white'>
        <MRHeader label="Cerca Malattia rara" />
      </Container>

      <BreadcrumbGF items={breadcrumbItems} />

      <Container fluid="lg" className="mt-lg-4 mb-lg-4 p-0 rounded-lg">

        <Container className='py-4'>

          <div className='w-100 mb-4 d-flex flex-row align-items-center justify-content-center'><FaListCheck className='me-2' /><Link to="/malattie-rare/questionari">Questionari</Link></div>

          <ContenitoreBase titolo="Centri di Riferimento Regionali">
            <Form.Group>
              <InputGroup className="mb-2">
                <InputGroup.Text id="basic-addon1" className='bg-white'><FaSearch /></InputGroup.Text>
                <Form.Control type="text" value={search} placeholder="Cerca per nome patologia o codice esenzione" onChange={e => setSearch(e.target.value)} style={search === "" ? { borderLeft: 0 } : { borderLeft: 0, borderRight: 0 }}></Form.Control>
                {search !== "" && (
                  <Button variant="outline-light" id="button-addon2" className="" onClick={() => setSearch("")} style={{ borderLeft: 0, borderColor: '#ced4da' }}>
                    <FaTimesCircle className="text-secondary" />
                  </Button>
                )}
              </InputGroup>
            </Form.Group>
            {centriFiltered && centriFiltered.length > 0 && (
              <Accordion activeKey={curAccordion}>
                {centriFiltered.sort(compare).map((centro, index) =>
                  <Accordion.Item key={index} onClick={() => clickItem(centro.KID)} eventKey={centro.KID} className="bg-light">
                    <Accordion.Header className='border rounded overflow-hidden mb-1'><strong>{centro.DESCRIZIONE}</strong></Accordion.Header>
                    <Accordion.Body>
                      <div className='p-2 border rounded'>
                        <Row>
                          <Col xs={12} md={2}>Codice: </Col>
                          <Col xs={12} md={10}><strong>{centro.CODICE}</strong></Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={2}>Indirizzo: </Col>
                          <Col xs={12} md={10}><strong dangerouslySetInnerHTML={{ __html: centro.NOTE }} /></Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={2}>Resp. Clinico:</Col>
                          <Col xs={12} md={10}><strong>{centro.RESP_CLINICO}</strong></Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={2}>Contatti:</Col>
                          <Col xs={12} md={10}>
                            <div dangerouslySetInnerHTML={{ __html: centro.CONTATTI }} />
                          </Col>
                        </Row>
                      </div>
                      <Table striped bordered hover className='mt-3'>
                        <thead className='bg-primary text-light'>
                          <tr>
                            <th>Descrizione</th>
                            <th>Codice esenzione</th>
                          </tr>
                        </thead>
                        <tbody>
                          {centro.ARR_MALATTIE_RARE.sort(compare).map((malattia, index) =>
                            <tr key={index}>
                              <td className={`${search.length > 0 ? malattia.DESCRIZIONE.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? 'bg-warning text-dark' : '' : ''}`}>{malattia.DESCRIZIONE}</td>
                              <td className={`${search.length > 0 ? malattia.CODICE_ESENZIONE.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? 'bg-warning text-dark' : '' : ''}`}>{malattia.CODICE_ESENZIONE}</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
              </Accordion>
            )}
          </ContenitoreBase>
        </Container>
      </Container>
    </>
  )
}

export default MRCerca;